import React from 'react';

const NotFound = () => {
    return (
        <div className='not-found'>Not found!!!!! Super super so so so sorry</div>
    )
}

export default NotFound;